<bn-loading-overlay></bn-loading-overlay>

<h5>CNAEs Permitidos para Grandes Empresas</h5>

<section class="pesquisa">
  <div class="container">
    <div class="mb-3 row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto">
        <button *ngIf="podeCadastrarEncerrar" 
          type="button" 
          [disabled]="!ideTranche" 
          class="btn btn-primary no-margin"
          placement="bottom"
          (click)="irParaCadastro()"
          ngbTooltip="Selecione esta opção para incluir uma Máscara CNAE permitido para Grandes Empresas">
          Cadastrar Nova Máscara CNAE</button>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button type="button" [disabled]="!ideTranche" class="btn btn-success no-margin" (click)="buscar(false)">
        Pesquisar</button>
      </div>
    </div>

    <div class="bn-form-group row" id="form-group-check">
        <div class="col-md-5">
          <label for="tranche">Cesta: </label>
          <select id="tranche" class="form-select" [(ngModel)]="ideTranche">
            <option [ngValue]=null>Selecione</option>
            <option [ngValue]="tranche.id" *ngFor="let tranche of tranches">
              {{tranche.numeroTranche}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
          </select>
        </div>
    </div>

    <form [formGroup]="pesquisaForm" class="mt-3 mx-auto">
      <div class="row mt-5" *ngIf="ideTranche">
        <div class="bn-form-group col-md-3">
          <label class="form-label" for="mascara">Máscara: 
            <i class="fa fa-question-circle help-subtitulo" placement="bottom"
            ngbTooltip="Máscara do Código CNAE"></i></label>
          <select id="mascara" class="form-select" formControlName="mascara">
            <option [ngValue]=null>Todos</option>
            <option [ngValue]="mascara.mascara" *ngFor="let mascara of mascaras">
              {{mascara.mascara}}</option>
          </select>
        </div>
        <div class="bn-form-group col-md-2">
          <label class="form-label" for="dataInicioVigencia">Data início vigência:</label>
          <bn-datepicker
              name="dataInicioVigencia"
              idInput="dataInicioVigencia"
              formControlName="dataInicioVigencia"
              ngDefaultControl>
          </bn-datepicker>
        </div>
        <div class="bn-form-group col-md-2">
          <label class="form-label" for="dataFimVigencia">Data fim vigência:</label>
          <bn-datepicker
              name="dataFimVigencia"
              idInput="dataFimVigencia"
              formControlName="dataFimVigencia"
              ngDefaultControl>
          </bn-datepicker>
        </div>
        <div class="bn-form-group col-md-2">
          <label class="form-label" for="tipoOperacao">Tipo da operação: </label>
          <select id="tipoOperacao" class="form-select" formControlName="tipoOperacao">
            <option [ngValue]=null>Todos</option>
            <option [ngValue]="operacao.value" *ngFor="let operacao of tipoOperacaoSelect">
              {{operacao.label}}
            </option>
          </select>
        </div>
        <div class="bn-form-group col-md-3">
          <label class="form-label" for="objetivoFinanciamento">Objetivo do financiamento: </label>
          <select id="objetivoFinanciamento" class="form-select" formControlName="objetivoFinanciamento">
            <option [ngValue]=null>Todos</option>
            <option [ngValue]="objetivo.value" *ngFor="let objetivo of objetivoFinanciamentoSelect">
              {{objetivo.label}} 
            </option>
          </select>
        </div>
      </div>
    </form>
  </div>

</section>
<app-cnae-permitido-listagem
  [cnaesPermitidos]="cnaesPermitidos"
  [msgSemResultado]="msgSemResultado"
  [dataHoraResultado]="dataHoraResultado"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  (aoMudarPagina)="mudancaPagina($event)"
  (exportarCnaesPermitidos)="exportarCnaesPermitidos()"
  [podeCadastrarEncerrar]="podeCadastrarEncerrar">
</app-cnae-permitido-listagem>